import { Injectable } from '@angular/core';
import { ServerErrorCode } from '../model/local/error/server-error-code';
import { NotificationUtil } from './notification.util';

export interface ServerErrorMessageResult {
  key: string;
  params?: Record<string, string>;
}

const KNOWN_CODES = new Set<string>(Object.values(ServerErrorCode));

function isKnownServerErrorCode(code: string): code is ServerErrorCode {
  return KNOWN_CODES.has(code);
}

@Injectable({
  providedIn: 'root',
})
export class ServerErrorUtil {
  constructor(private readonly notificationUtil: NotificationUtil) {}

  getServerErrorMessage(
    error: unknown,
    failsafeKey = 'ERROR.OPERATION_UNSUCCESSFUL'
  ): ServerErrorMessageResult {
    const code = (error as { error?: { errorCode?: string } })?.error
      ?.errorCode;
    if (code != null && typeof code === 'string') {
      if (isKnownServerErrorCode(code)) {
        return { key: `SERVER_ERROR_CODE.${code}` };
      }
      return {
        key: 'ERROR.OPERATION_UNSUCCESSFUL_WITH_CODE',
        params: { errorCode: code },
      };
    }
    return { key: failsafeKey };
  }

  showServerError(
    error: unknown,
    failsafeKey = 'ERROR.OPERATION_UNSUCCESSFUL'
  ): void {
    const result = this.getServerErrorMessage(error, failsafeKey);
    this.notificationUtil.error(result.key, result.params ?? {});
  }
}
